'use client'

import Typography, { type TypographyProps } from '@mui/material/Typography'
import { useSyncExternalStore } from 'react'
import { formatDateTimeToDisplay, formatDateToDisplay, TIME_ZONE } from '@/app/_shared/utils'

interface DateTextProps extends Omit<TypographyProps, 'children'> {
	value: Date | string | null | undefined
	withTime?: boolean
	/** Shown when there is no value. */
	fallback?: string
}

const noSubscribe = () => () => {}

const format = (value: DateTextProps['value'], withTime: boolean, timeZone?: string) =>
	withTime ? formatDateTimeToDisplay(value, timeZone) : formatDateToDisplay(value, timeZone)

/**
 * A date in the viewer's zone. The server renders it in UTC; after hydration the browser
 * re-renders it in its own zone.
 */
export const DateText: React.FC<DateTextProps> = ({ value, withTime = false, fallback = '', ...props }) => {
	const text = useSyncExternalStore(
		noSubscribe,
		() => format(value, withTime),
		() => format(value, withTime, TIME_ZONE.UTC),
	)
	return (
		<Typography component='span' variant='inherit' {...props}>
			{text || fallback}
		</Typography>
	)
}
